<template>
	<v-container class="fill-height">
		<v-row justify="space-around">
			<v-col cols="4" class="text-center"> <span>SSO - Logging in, hold on please.</span> <br /> </v-col>
		</v-row>
	</v-container>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters, mapActions } from 'vuex';
import api from '@/api';
export default {
	name: 'GoogleCallback',
	props: {
		code: {
			type: String,
			required: false,
		},
	},
	computed: {
		...mapGetters('main', ['appURL']),
		chromeExtensionID() {
			return process.env.VUE_APP_CHROME_EXTENSION_ID;
		},
	},
	data() {
		return {};
	},
	methods: {
		...mapActions(['loginWithToken']),
	},
	async mounted() {
		const response = await api.loginWithSSOCode(this.code).catch((err) => {
			console.error(err);
			this.$toast.error(err, { timeout: 3000 });
		});
		this.resp = response;
		if (response.token) {
			await this.loginWithToken(response.token);
		}
	},
};
</script>

<style scoped></style>
